import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 62.957 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="running-solid"
      className="icon"
      d="M41.164,14.529A7.264,7.264,0,1,0,33.9,7.264,7.264,7.264,0,0,0,41.164,14.529ZM17.206,48.046l-2.24,5.224H4.843a4.843,4.843,0,1,0,0,9.686H16.564a7.249,7.249,0,0,0,6.676-4.4l1.33-3.105-1.615-.953a14.411,14.411,0,0,1-5.749-6.449ZM58.114,33.9H51.451L47.507,25.84a14.522,14.522,0,0,0-9.35-7.709L27.4,14.931a14.467,14.467,0,0,0-12.234,2.594l-6,4.6a4.842,4.842,0,1,0,5.893,7.685l6.007-4.6a4.713,4.713,0,0,1,3.824-.929l2.225.661L21.442,38.168a9.711,9.711,0,0,0,3.98,12.154l12.861,7.593L34.126,71.192a4.842,4.842,0,1,0,9.242,2.894l4.788-15.294a7.294,7.294,0,0,0-3.275-8.231L35.613,45.09l4.738-11.847,3.068,6.27a7.309,7.309,0,0,0,6.524,4.07h8.171a4.842,4.842,0,1,0,0-9.684Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
